import React, { useState, useEffect, createRef } from "react";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import dSService from "../services/eom-disease-states-service";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { selectRow, clearSelectedRow } from "../state/reducers/eomSlice";
import { Multiselect } from "multiselect-react-dropdown";

const CreateDrug = ({ history }) => {
  const { id } = useParams();
  let { selectedRow, year } = useSelector(selectRow);
  const dispatch = useDispatch();

  const [showError, setShowError] = useState(false);
  const [drug_name, setDrugname] = useState("");
  const [gpi, setGPI] = useState("");
  const [ndc, setNDC] = useState("");
  useEffect(() => {
    if (selectedRow?.ndc || selectedRow?.gpi || selectedRow?.drug_name) {
      setGPI(selectedRow.gpi);
      setNDC(selectedRow.ndc);
      setDrugname(selectedRow.drug_name);
    }
    return function cleanup() {
      dispatch(clearSelectedRow());
    };
  }, [selectedRow]);

  useEffect(() => {
    if (id) getDrugDetails(id);
  }, [id]);
  const [loading, setLoading] = useState(false);
  const getDrugDetails = async (id) => {
    try {
      setLoading(true);
      const resp = await dSService.getDrug(id);
      setGPI(resp?.gpi);
      setNDC(resp?.ndc);
      setDrugname(resp?.drug_name);
      setDetail([resp?.detail_disease_state]);
      setGeneral([resp?.disease_state]);
      setSHP([resp?.shp_disease_state]);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while creating drug details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const onSubmit = async (data) => {
    try {
      if (
        !(ndc || gpi || drug_name) ||
        !(general?.length || gSearch?.length) ||
        !(detail?.length || dSearch?.length) ||
        !(shp?.length || shpSearch?.length)
      ) {
        setShowError(true);
        return;
      }

      setLoading(true);
      let data = {};
      data["gpi"] = gpi;
      data["ndc"] = ndc;
      data["drug_name"] = drug_name;

      data["disease_state"] = general?.length
        ? general.join(",")
        : gSearch.join(",");
      data["detail_disease_state"] = detail?.length
        ? detail.join(",")
        : dSearch.join(",");
      data["shp_disease_state"] = shp?.length
        ? shp.join(",")
        : shpSearch.join(",");

      if (id) {
        data["id"] = id;
        await dSService.updateDrug(data);
      } else {
        await dSService.createDrug(data);
      }
      if (year) {
        await history.push("/eom");
      } else {
        await history.push("/diseaseState");
      }

      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting drug details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const [dSearch, setDSearch] = useState([]);
  const [gSearch, setGSearch] = useState([]);
  const [shpSearch, setSHPSearch] = useState([]);
  const multiselectRef = createRef();
  const multiselectRef1 = createRef();
  const multiselectRef2 = createRef();

  const [generalList, setGeneralList] = useState([]);
  const [general, setGeneral] = useState([]);
  const [shpList, setSHPList] = useState([]);
  const [shp, setSHP] = useState([]);

  const [detailList, setDetailList] = useState([]);
  const [detail, setDetail] = useState([]);
  useEffect(() => {
    getGeneralDiseaseStates();
    getSHPDiseaseStates();
    getDetailDiseaseStates();
  }, []);
  const getGeneralDiseaseStates = async () => {
    try {
      setLoading(true);
      let resp = await dSService.getGeneralDS();
      if (resp) {
        setGeneralList(resp);
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting general disease states. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const getSHPDiseaseStates = async () => {
    try {
      setLoading(true);
      let resp = await dSService.getSHPDS();
      if (resp) {
        setSHPList(resp);
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting general disease states. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const getDetailDiseaseStates = async () => {
    try {
      setLoading(true);
      let resp = await dSService.getDetailDS();
      if (resp) {
        setDetailList(resp);
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting general disease states. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{id ? "EDIT" : "CREATE"}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Drug name
              </label>
              {!(gpi || ndc) && (
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              )}

              <input
                id="drug_name"
                name="drug_name"
                type="text"
                placeholder="Drug name"
                value={drug_name}
                onChange={(e) => setDrugname(e.target.value)}
                className={` ${
                  showError && !drug_name && !gpi && !ndc
                    ? "border-red-400"
                    : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {showError && !drug_name && !gpi && !ndc && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify Drug name or GPI or NDC
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                GPI
              </label>
              {!(drug_name || ndc) && (
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              )}

              <input
                id="gpi"
                name="gpi"
                type="text"
                placeholder="GPI"
                onChange={(e) => setGPI(e.target.value)}
                value={gpi}
                className={` ${
                  showError && !drug_name && !gpi && !ndc
                    ? "border-red-400"
                    : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {showError && !drug_name && !gpi && !ndc && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify Drug name or GPI or NDC
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                NDC
              </label>
              {!(gpi || drug_name) && (
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              )}

              <input
                id="ndc"
                name="ndc"
                type="text"
                placeholder="NDC"
                onChange={(e) => setNDC(e.target.value)}
                value={ndc}
                className={` ${
                  showError && !drug_name && !gpi && !ndc
                    ? "border-red-400"
                    : ""
                } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {showError && !drug_name && !gpi && !ndc && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify Drug name or GPI or NDC
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                General Disease State
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              {generalList ? (
                <Multiselect
                  name="disease_state"
                  selectedValues={general}
                  isObject={false}
                  displayValue="name"
                  options={generalList}
                  ref={multiselectRef}
                  selectionLimit={1}
                  onSearch={(val) => setGSearch([val])}
                  onSelect={(e) => {
                    let currentValue =
                      multiselectRef.current.getSelectedItems();
                    setGeneral(currentValue);
                  }}
                  onRemove={(e) => {
                    setGeneral([]);
                  }}
                />
              ) : (
                ""
              )}
              {!(general?.length || gSearch?.length) && showError && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must select general disease state
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                SHP Disease State
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              {shpList ? (
                <Multiselect
                  name="disease_state"
                  selectedValues={shp}
                  isObject={false}
                  displayValue="name"
                  options={shpList}
                  ref={multiselectRef1}
                  selectionLimit={1}
                  onSearch={(val) => setSHPSearch([val])}
                  onSelect={(e) => {
                    let currentValue =
                      multiselectRef1.current.getSelectedItems();
                    setSHP(currentValue);
                  }}
                  onRemove={(e) => {
                    setSHP([]);
                  }}
                />
              ) : (
                ""
              )}
              {!(shp?.length || shpSearch?.length) && showError && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must select SHP disease state
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Detail Disease State
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              {detailList ? (
                <Multiselect
                  name="deatil_disease_state"
                  selectedValues={detail}
                  isObject={false}
                  displayValue="name"
                  options={detailList}
                  ref={multiselectRef2}
                  selectionLimit={1}
                  onSearch={(val) => setDSearch([val])}
                  onSelect={(e) => {
                    let currentValue =
                      multiselectRef2.current.getSelectedItems();
                    setDetail(currentValue);
                  }}
                  onRemove={(e) => {
                    setDetail([]);
                  }}
                />
              ) : (
                ""
              )}
              {!(detail?.length || dSearch?.length) && showError && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must select detail disease state
                </p>
              )}
            </li>

            <li className="inline-block text-sm leading-8 w-full">
              <button
                className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                aria-label="Create drug"
                onClick={() => onSubmit()}
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreateDrug)
);
